import {getUserData} from "../modulesUtils";

let subscriptionUrl = null;
let handlerUrl = null;

function userNotPremium(anonymous, trSelector) {
    const notPremium = '<a href="' + subscriptionUrl + '" class=\"lnk\" title=\"Para ver este contenido debes suscribirte\">ver</a> ';
    const notRegister = '<a href="#suscriptionModal" class="lnk" title="Para ver este contenido debes ser suscriptor" data-lightbox="">ver</a>';

    const message = anonymous ? notRegister : notPremium;
    trSelector.html(message);

    //Si el usuario no es premium, interceptar el ordenamiento por FA y parar.
    const faSorting = document.querySelectorAll('span.sortable[title="Puntuación"]');
    faSorting.forEach(item => {
        item.classList.remove('smartfollow');
        item.addEventListener('click', (e) => {
            $('.user-session-button').trigger('click');
        });
    });
}

function generateScore(score) {
    if (isNaN(score)) {
        return '-';
    }
    let title = null;
    if (score > 4) {
        title = 'Puntuación: ' + score + ' | MUY INFRAVALORADA';
    } else if (score > 2) {
        title = 'Puntuación: ' + score + ' | INFRAVALORADA';
    } else if (score > -1) {
        title = 'Puntuación: ' + score + ' | NEUTRAL';
    } else if (score > -3) {
        title = 'Puntuación: ' + score + ' | SOBREVALORADA';
    } else {
        title = 'Puntuación: ' + score + ' | MUY SOBREVALORADA';
    }

    let div = $('<div title="' + title + '" class="ei-fundamental-synthesis-value"></div>');
    let count = score;
    for (let i = 0; i < 6; i++) {
        if (score < 0 && count < 0) {
            div.append('<div class="square updateDown"></div>');
            count++;
        } else if (score > 0 && count > 0) {
            div.append('<div class="square updateUp"></div>');
            count--;
        } else {
            div.append('<div class="square"></div>');
        }
    }

    return div;
}

function returnJsonNotation(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return str;
    }
}

function loadFAScore(container) {
    let tickers = [];
    container.each(function () {
        tickers.push($(this).data('instrument'));
    });

    var path = handlerUrl + '/' + tickers.join(',');
    $.get(path, function (data) {
        let scores = {};
        const json = returnJsonNotation(data);
        json.forEach(function (item) {
            scores[item.idTicker] = item.score;
        });

        container.each(function () {
            const elem = $(this);
            const tickerId = elem.data('instrument');
            const score = scores.hasOwnProperty(tickerId) ? scores[tickerId] : '-';

            elem.html(generateScore(score));
        });
    });
}

function checkUserPermission(userData, trSelector) {
    let isPremium = userData && userData.hasOwnProperty('premium') && userData.premium === true;
    isPremium = isPremium || userData && userData.hasOwnProperty('trial') && userData.trail === true;

    if (isPremium) {
        return loadFAScore(trSelector);
    } else {
        return userNotPremium(false, trSelector);
    }
}

/**
 * Módulo para cargar vía AJAX las calificaciones de análisis fundamental si el usuario es premium en las fichas.
 */
export const premiumFAMultiple = async () => {

    const faSelector = $('.stock-index-fa-scores');
    if (!faSelector.length) {
        return null;
    }

    subscriptionUrl = faSelector.data('subscriptionurl');
    handlerUrl = faSelector.data('handlerurl');

    try {
        const userData = await getUserData();
        checkUserPermission(userData, faSelector);
    } catch (e) {
        return userNotPremium(true, faSelector);
    }
}
